export default [

    {
        path: '/SiteHomePage',
        name: 'SiteHomePage',
        component: () => import('../../views/Site/SiteHomePage.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/SitePublishHome',
        name: 'SitePublishHome',
        component: () => import('../../views/Site/SitePublishHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/SitePublishingNode', // 维保发布
        name: 'SitePublishingNode',
        component: () => import('../../views/Site/CirculationNodes/SitePublishingNode.vue'),

    },
    {
        path: '/SiteAuditNode', // 维保审核
        name: 'SiteAuditNode',
        component: () => import('../../views/Site/CirculationNodes/SiteAuditNode.vue'),

    },
    {
        path: '/SiteIssuingNode', //维保签发
        name: 'SiteIssuingNode',
        component: () => import('../../views/Site/CirculationNodes/SiteIssuingNode.vue'),

    },
    {
        path: '/draftSiteHome',
        name: 'draftSiteHome',
        component: () => import('../../views/Site/Sitedraft/draftSiteHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/SitereadonlyHome',
        name: 'SitereadonlyHome',
        component: () => import('../../views/Site/Sitereadonly/SitereadonlyHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/SiteHistoryPage',
        name: 'SiteHistoryPage',
        component: () => import('../../views/Site/historyPage/SiteHistoryPage.vue'),
    },
    { //文件下载
        path: '/SiteFileDownload',
        name: 'SiteFileDownload',
        component: () => import('../../views/Site/Documents/SiteFileDownload.vue'),
    },
    { //文件生成
        path: '/SiteGenerateDocument',
        name: 'SiteGenerateDocument',
        component: () => import('../../views/Site/Documents/SiteGenerateDocument.vue'),
    },

]